<script lang="ts">
	import Input from "@components/form/Input.svelte";
	import Labelled from "@components/form/Labelled.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";

	type InputEvent = Event & { currentTarget: EventTarget & HTMLInputElement };
	type InputEventHandler = ((event: InputEvent) => void) | null | undefined;

	const {
		wrapperClass,
		label,
		children,
		oninvalid: _oninvalid,
		oninput: _oninput,
		onchange: _onchange,
		...rest
	}: ComponentProps<typeof Input> & {
		wrapperClass?: ClassValue;
		children: Snippet;
		label?: HTMLLabelAttributes;
	} = $props();

	const oninvalid = _oninvalid as InputEventHandler;
	const oninput = _oninput as InputEventHandler;
	const onchange = _onchange as InputEventHandler;

	const id = $derived(`${rest.id ?? rest.name ?? ""}-${crypto.randomUUID()}`);
	const isRadioOrCheckbox = $derived(["checkbox", "radio"].includes(String(rest.type)));

	let validationError = $state("");
</script>

<Labelled
	{wrapperClass}
	required={rest.required}
	label={{ ...label, for: id }}
	horizontal={isRadioOrCheckbox}
	error={validationError}
>
	{@render children()}
	{#snippet content()}
		<Input
			class={[isRadioOrCheckbox ? "shrink-0" : "flex-1", rest.class]}
			{...rest}
			{id}
			oninvalid={(event: InputEvent): void => {
				validationError = event.currentTarget.validationMessage;
				oninvalid?.(event);
			}}
			oninput={(event: InputEvent): void => {
				if (event.currentTarget.validity.valid) {
					validationError = "";
				}
				oninput?.(event);
			}}
			onchange={(event: InputEvent): void => {
				if (event.currentTarget.validity.valid) {
					validationError = "";
				}
				onchange?.(event);
			}}
		/>
	{/snippet}
</Labelled>
